// extracted by mini-css-extract-plugin
export default {"container":"container-PDKna","subjectTabName":"subjectTabName-OrybY"};